<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Categoria
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: 80px;width: auto;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Configuraciones
    
    v-flex(xs12 style='margin-top:40px;' )
        v-layout(align-center='', justify-center='', wrap='', fill-height='')
            v-flex(xs8)
                v-text-field(outline
                    v-model="form.whatsapp"
                    prepend-inner-icon="phone"
                    label="Whatsapp:"
                    style="height: 56px;width: 89%;margin: 0px 32px 10px;")

                v-text-field(outline
                    v-model="form.correo"
                    prepend-inner-icon="mail"
                    label="Correo electrónico:"
                    style="height: 56px;width: 89%;margin: 0px 32px 10px;")

                v-text-field(outline
                    v-model="form.telefono"
                    prepend-inner-icon="phone"
                    label="Teléfono:"
                    style="height: 56px;width: 89%;margin: 0px 32px 10px;")

                v-text-field(outline
                    v-model="form.instagram"
                    prepend-inner-icon="mail"
                    label="Instagram:"
                    style="height: 56px;width: 89%;margin: 0px 32px 10px;")

                v-text-field(outline
                    v-model="form.ubicacion"
                    prepend-inner-icon="mail"
                    label="Link de ubicación:"
                    style="height: 56px;width: 89%;margin: 0px 32px 10px;")

                v-textarea(outline
                    v-model="form.textcompartir"
                    prepend-inner-icon="description"
                    label="Texto para compartir:"
                    style="width: 89%;margin: 0px 32px -18px;")

                v-text-field(outline
                    type='number'
                    v-model="form.minimo"
                    min='0'
                    prepend-inner-icon="money"
                    label="Monto mínimo para pedidos:"
                    style="height: 56px;width: 89%;margin: 0px 32px 10px;")

            v-flex(xs8 style='display:flex;justify-content:center;')
                v-btn(style="background:#0093dd;border-radius:10px;", @click.native='save' v-if="!loading") Guardar
                v-progress-circular(indeterminate='', v-if="loading" style='border-radius: 10px;color: #0093dd;')
</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
export default {
  name: "mSettings",
  data: () => ({
    settings: [],
    loading: false,
    ruta: server + ":" + port,
    form: {
      whatsapp: "",
      correo: "",
      minimo: 0,
      telefono: "",
      textcompartir: "",
      instagram: "",
      ubicacion: ""
    },
    defaultForm: {
      whatsapp: "",
      correo: "",
      minimo: 0,
      telefono: "",
      textcompartir: "",
      instagram: "",
      ubicacion: ""
    },
    cre: "",
    mod: "",
    elm: ""
  }),
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    verificacion() {
      for (let i = 0; i < this.$store.state.webamairca.permisos.length; i++) {
        if (this.$store.state.webamairca.permisos[i].ruta === "Settings") {
          for (
            let j = 0;
            j < this.$store.state.webamairca.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.webamairca.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.webamairca.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.webamairca.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    save() {
      if (this.settings.length > 0) {
        this.form._id = this.settings[0]._id;
        this.loading = true;
        Api.put("settings", this.form)
          .then(res => {
            this.form = Object.assign({}, this.defaultForm);
            this.$swal.fire(
              "Felicidades.!",
              "Modificación realizada exitosamente.",
              "success"
            );
            this.loading = false;
            this.initialize();
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
            this.$swal.fire(
              "¡Atención!",
              "Error encontrado, verifique los datos o llame al administrador.",
              "error"
            );
          });
      } else {
        this.loading = true;
        Api.post("settings", this.form)
          .then(res => {
            this.form = Object.assign({}, this.defaultForm);
            this.$swal.fire(
              "Felicidades.!",
              "Registro realizado exitosamente.",
              "success"
            );
            this.loading = false;
            this.initialize();
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
            this.$swal.fire(
              "¡Atención!",
              "Error encontrado, verifique los datos o llame al administrador.",
              "error"
            );
          });
      }
    },
    initialize() {
      Api.get("settings").then(res => {
        if (res.data && res.data.length > 0) {
          this.settings = res.data;
          this.form.whatsapp = res.data[0].whatsapp ? res.data[0].whatsapp : "";
          this.form.correo = res.data[0].correo ? res.data[0].correo : "";
          this.form.textcompartir = res.data[0].textcompartir ? res.data[0].textcompartir : "";
          this.form.minimo = res.data[0].minimo ? res.data[0].minimo : 0;
          this.form.telefono = res.data[0].telefono ? res.data[0].telefono : "";
          this.form.instagram = res.data[0].instagram ? res.data[0].instagram : "";
          this.form.ubicacion = res.data[0].ubicacion ? res.data[0].ubicacion : "";
        }
      });
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/scss/categoria.scss";
</style>
